// Libs
import React from 'react'
import PropTypes from 'prop-types'

import {
  Backdrop,
  Dialog,
  Close,
  ModalTitle
} from './ModalResponsive'

const Modal = ({ modalRef, title, size, style, backdropStyle, styleBtnClose, onToggleModal, className, hideCloseIcon, children }) => {
  return (
    <Backdrop
      innerRef={modalRef}
      className={className}
      onClick={onToggleModal}
      style={backdropStyle}
    >
      <Dialog
        className='modal-dialog'
        size={size}
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <ModalTitle type='medium' title={title} />}
        <Close
          onClick={onToggleModal}
          style={styleBtnClose}
          hideCloseIcon={hideCloseIcon}
        />
        {children}
      </Dialog>
    </Backdrop>
  )
}
export default Modal

Modal.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOf(['large']),
  style: PropTypes.object,
  onToggleModal: PropTypes.func
}

Modal.defaultProps = {
  title: '',
  size: 'large',
  style: {},
  onToggleModal: () => { }
}



// WEBPACK FOOTER //
// ./src/components/common/Modal.js